import clsx from "clsx";
import React from "react";
import { FieldValues, Path, UseFormRegister, UseFormTrigger } from "react-hook-form";

import { VALIDATION_MESSAGE } from "constants/validation";
/**
 * チェックボックスコンポーネント
 * - 初期状態ではチェックはつかない
 * - クリックするとチェックがつく
 * - もう一度クリックするとチェックが外れる
 * - テキストクリックでもチェックが機能する
 * */
const Checkbox = <T extends FieldValues>({
  label,
  name,
  value,
  checkboxClassName,
  register,
  isDisabled = false,
  isNeedAtLeastOne = false,
  onClick,
  trigger,
  validationMode = "onChange",
  fontSize = "text-s",
  isCircleCheckbox = false,
  dataTestId,
}: {
  label: string;
  name: Path<T>;
  value?: string;
  checkboxClassName?: string;
  isDisabled?: boolean;
  register?: UseFormRegister<T>;
  isNeedAtLeastOne?: boolean;
  onClick?: () => void;
  trigger?: UseFormTrigger<T>;
  validationMode?: "onChange" | "onBlur";
  fontSize?: string;
  isCircleCheckbox?: boolean;
  dataTestId?: string;
}) => {
  const registration = register
    ? isNeedAtLeastOne
      ? register(name, {
        validate: {
          atLeastOneRequired: (value: string[]) => (value && value.length >= 1) || VALIDATION_MESSAGE.ONE_OR_MORE,
        },
        [validationMode]: () => {
          trigger?.(name);
        },
      })
      : register(name)
    : {};

  return !isDisabled ? (
    <label className={clsx("flex w-fit cursor-pointer flex-row items-center", fontSize, checkboxClassName)} data-testid={dataTestId}>
      <input
        {...registration}
        type="checkbox"
        disabled={isDisabled}
        value={value}
        onClick={onClick}
        id={`checkbox-${label}`}
        className="peer absolute opacity-0"
      />
      <div
        className={clsx(
          "relative mr-2.5 flex h-6 w-6 items-center justify-center rounded border border-form-border bg-form-background hover:border-text-black peer-checked:bg-primary peer-checked:[&_img]:!inline-block peer-checked:border-0 peer-checked:hover:bg-link-dark",
          isCircleCheckbox && "!mr-2 rounded-full"
        )}
      >
        <img src="/svg/check.svg" className={clsx("hidden", isCircleCheckbox && "h-[13px] w-3")} alt="Check" />
      </div>
      <span className={clsx("flex-shrink-0", isCircleCheckbox && "text-gray")}>{label}</span>
    </label>
  ) : (
    <div className={clsx("flex cursor-not-allowed items-center gap-[10px] text-disabled", fontSize)}>
      <div className="block h-[24px] w-[24px] rounded bg-form-disabledBackground" />
      <span className="flex-shrink-0">{label}</span>
    </div>
  );
};

export default Checkbox;
